module.exports = require('./helpers/bundle-url').getBundleURL('2LpMj') + "sh.81241227.png" + "?" + Date.now();